import React,{useContext,useState} from 'react';
import {Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {API_URL} from './config';
import {AuthContext} from './AuthContext';
import {UserRoleContext} from './GetUserRole';
export default function LogoutButton({className,sx}){
    const navigate=useNavigate(),{refreshAuth}=useContext(AuthContext),{refreshRole}=useContext(UserRoleContext),[busy,setBusy]=useState(false);
    const logout=async()=>{setBusy(true);try{const body=new FormData();body.append('action','logout');const response=await fetch(API_URL+'auth.php',{method:'POST',body,credentials:'include'});if(!response.ok)throw Error('Logout failed');await refreshAuth();refreshRole();navigate('/auth');}catch{setBusy(false)}};
    return <Button type="button" className={className} sx={sx} disabled={busy} onClick={logout}>{busy?'Logging out…':'Logout'}</Button>;
}
